import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Videojs from "../video-js";
import Image from "../../elements/image";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import gsap from 'gsap';
import { getOverallSettingsClasses, mobileIs, loadScrollMagic } from "../../utils/siteUtils";

import "./style.scss";
let videoLoadStatus = false;
const MediaDisplay = props => {
	const { fields } = props;
  const  { video, poster, autoplay, MobilePoster, MobileVideo } = fields
  const rootEl = useRef();
  const videoEl = useRef();
  const mainEl = useRef();
  const videoMainEl = useRef();
  const isMobile = mobileIs();
	const [showControl, setShowControl] = useState(false);
	let videoOptions = 
  ( video && video.value) 
    ? {
        sources: [
        {
          src: video.value.src,
          type: video.value.mimeType
        }
        ],
        poster:  autoplay.value ? null : poster ? poster.value.src : null,
        videoTitle: '',
        autoplay: autoplay.value,
        controls: autoplay.value == true ? false : true,
        muted: true,
        loop : true
  }: null;
	let videoOptionsMobile = 
  ( MobileVideo && MobileVideo.value) 
    ? {
        sources: [
        {
          src: MobileVideo.value.src,
          type: MobileVideo.value.mimeType
        }
        ],
        poster:  MobilePoster ? MobilePoster.value.src : null,
        videoTitle: '',
        autoplay: autoplay.value,
        controls: true,
        muted: true,
        loop : true
  }: null;
  useEffect(() => {
    let pcHeight =  window.innerHeight -  window.innerHeight/5;
    let ScrollMagic, controller, scene, scene2, tl;
    ScrollMagic = loadScrollMagic();
    tl = gsap.timeline();
    if(isMobile){
      tl.add(gsap.to(videoMainEl.current,{
        margin: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        ease: 'linear'
      },1)).add(gsap.to(videoMainEl.current,{
        margin: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      },2)).add(gsap.to(videoMainEl.current,{
        marginTop: 120,
        marginLeft: 50,
        marginBottom: 120,
        marginRight: 50,
        width: window.innerWidth - 100,
        height: window.innerHeight - 240,
      },3))
    }else{
      tl.add(gsap.to(videoMainEl.current,{
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        width: window.innerWidth,
        height: window.innerHeight
      },1))
      .add(gsap.to(videoMainEl.current,{
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        width: window.innerWidth,
        height: window.innerHeight
      },2))
      .add(gsap.to(videoMainEl.current,{
        marginTop: 0,
        marginLeft: '22vw',
        marginRight: '22vw',
        width: window.innerWidth * 0.56,
        height:  window.innerWidth * 0.56 * 0.5625
      },3))
    }

    controller = new ScrollMagic.Controller();
    scene2 = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 0,
      offset:  -window.innerHeight + (window.innerHeight/5)*2,
      duration: pcHeight * 2.5
    })
    .setTween(tl)
    .addTo(controller);
    scene2.on("progress", function(event) {
      let ep = event.progress;
      let es = event.scrollDirection;
      if( ep > 0.3 && autoplay.value && videoLoadStatus && videoLoadStatus && videoEl.current){
        videoEl.current.player.play()
        setTimeout(v=>{
          setShowControl(true)
        },100)
      }
      if( ep > 0.3 && es === 'FORWARD' && !autoplay.value ){
        setShowControl(true)
      }
      if( ep < 0.3 && es === 'REVERSE'){
        setShowControl(false)
      }
    })

    controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 0,
      duration: pcHeight * 1
    })
    .setPin(rootEl.current)
    // .setTween(tl)
    .addTo(controller);
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      scene && scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    }
  }, []);
  useEffect(() => {
    setTimeout(v=>{
      if(!showControl && videoEl.current){
        videoEl.current.player.pause()
      }
    },100)
  },[showControl])
  const videoLoaded = () => {
    videoLoadStatus = true
  }
  const onScroll = () => {
    if(mainEl.current && videoEl.current){
      let top = mainEl.current.getBoundingClientRect().top;
      let height = mainEl.current.getBoundingClientRect().height;
  
      if( Math.abs(top) > height && top<0){
        videoEl.current.player.pause()
      }
      if( Math.abs(top) < height && top>0){
        videoEl.current.player.pause()
        setShowControl(false)
      }
      if( Math.abs(top) > window.innerHeight && Math.abs(top) < height && top<0 && autoplay.value ){
        videoEl.current.player.play()
      }
    }
  }
  const videoPlayPressed = () => {
  }
	
	const rootClasses = classNames("mediaDisplay", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} ref={mainEl} datasourceid={props.rendering.dataSource}>
      <div className={classNames("mediaDisplay-content", autoplay.value ? 'autoplay' :'')} ref={rootEl}>
        <div className={classNames("mediaDisplay-video",showControl? null : 'hideControl')} ref={videoMainEl}>
          
          { ((!isMobile && video && !video.value) || (MobileVideo && !MobileVideo.value && isMobile)) && 
            <Image className="img" id={'mediaDisplay-videoMediaModel'} { ...isMobile ? MobilePoster.value : poster.value} />
          }
          { ((!isMobile && video && video.value) || (MobileVideo && MobileVideo.value && isMobile)) && 
            <Videojs {...isMobile ? videoOptionsMobile : videoOptions}  id={'mediaDisplay-videoMediaModel'} videoPlayPressed={videoPlayPressed} videoLoaded={videoLoaded} ref={videoEl}/>
          }

        </div>
      </div>
    </div>
  )
};
export default MediaDisplay;
